<template>
  <div class="widget" :class="`widget--${type} ${className}`">
    <h2 class="header t-h2">{{ header }}</h2>
    <div class="widget-wrapper">
      <slot />
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed, toRefs } from 'vue'

import WIDGETS_SETTINGS from '@/constants/widgets-settings'
import type { BoardLayout, WidgetType } from '@/types'

const props = defineProps<{
  type: BoardLayout
  color?: string
  name: WidgetType
}>()

const { name } = toRefs(props)

const header = WIDGETS_SETTINGS[name.value].header
const className = WIDGETS_SETTINGS[name.value].class ?? ''
const color = WIDGETS_SETTINGS[name.value].color ?? props.color ?? '#ffffff'

const borderRadius = computed(() =>
  name.value === 'StudentArtGalleryWidget' ? 0 : '17px'
)
</script>
<style lang="scss" scoped>
.widget {
  position: absolute;
  width: vw();
  padding: 0 vw(170px);

  &--fullscreen {
    top: 0;
    left: 0;
    z-index: 2;
    width: vw();
    height: vh();
    padding: 0;
  }

  &--framed {
    padding: 0 vw(166px) 0 vw(165px);
  }

  &.student-art-gallery {
    padding: 0;
  }
}

.widget-wrapper {
  width: 100%;
  height: vh(1820px);
  overflow: hidden;
  border-radius: v-bind(borderRadius);

  .widget--framed & {
    height: vh(2820px);
  }

  .widget--fullscreen & {
    height: 100%;
    border-radius: 0;
  }
}

.header {
  padding-left: vw(66px);
  margin-bottom: vh(46px);
  color: v-bind(color);
  text-align: left;

  .widget--fullscreen & {
    display: none;
  }

  .student-art-gallery & {
    padding-left: vw(238px);
  }
}
</style>
